// config/api.js
import axios from 'axios';

const BASE_URL = '';

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  // withCredentials: true
});

// Request Interceptor
apiClient.interceptors.request.use(
  config => {
    // Session Headers
    const sessionId = localStorage.getItem('sessionId');
    const database = localStorage.getItem('database');
    
    if (sessionId) {
      config.headers['X-Openerp-Session-Id'] = sessionId;
    }

    if (database) {
      config.headers['X-Database'] = database;
    }

    // Log in development
    if (import.meta.env.DEV) {
      console.log('🌐 API Request:', {
        url: `${config.baseURL}${config.url}`,
        method: config.method,
        data: config.data,
        timestamp: new Date().toISOString()
      });
    }

    return config;
  },
  error => Promise.reject(error)
);

export default apiClient;